import React, { memo, useCallback } from 'react';

import { Box, TextField, Typography } from '@material-ui/core';

import type { EmaLabelFieldProps } from './EMALabelSeparation.types';
import Styles from './EMALabelSeparation.styles';

const EMALabelField = ({ section, value, error, onChange }: EmaLabelFieldProps) => {
  const classes = Styles();
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange(section, event.target.value);
    },
    [onChange, section]
  );

  return (
    <Box className={classes.labelRow}>
      <Typography variant='body1' component='div' className={classes.labelText}>
        {section.replace(/_/g, ' ')}
      </Typography>
      <TextField
        error={Boolean(error)}
        className={classes.textField}
        onChange={handleChange}
        value={value ?? ''}
        fullWidth
        id={section}
        helperText={error}
        InputProps={{
          classes: { input: classes.input },
          disableUnderline: true,
          inputProps: { inputMode: 'numeric', pattern: '[0-9]*' }
        }}
      />
    </Box>
  );
};

export default memo(EMALabelField);
